<template>
  <div>
    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "url": "https://www.melo.io/blog",
            "headline": "Le moteur de recherche des professionnels de l'immobilier - Blog",
            "description": "Melo vous accompagne dans toutes les questions relatives au marché de immobilier !",
            "datePublished": "2020-04-10T17:47:50.000Z",
            "dateModified": "2019-04-11T09:20:51.000Z",
            "image": {
              "@type": "ImageObject",
              "url": "https://www.melo.io/assets/socials/fb-cover.png"
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.melo.io/blog"
            },
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.melo.io",
              "name": "Melo",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.melo.io/assets/socials/fb-profile.png",
                "width": 1000,
                "height": 1000
              }
            },
            "author": {
              "@type": "Person",
              "name": "Louise Aubry"
            }
          }
        ]
      }
    </script>

    <div class="container">
      <b-row class="bg-light-blue py-5 mb-5 border-radius justify-content-center">
        <h1>Blog</h1>
      </b-row>

      <div v-for="category in categories" :key="category.slug" class="mb-5">
        <router-link :to="{ name: 'category', params: { category: category.slug } }" class="category-title">
          {{ category.name }}
        </router-link>

        <b-row align-v="center" class="px-3 px-md-0">
          <b-col v-for="article in getLatestArticlesByCategory(category)" :key="article.id" md="4"
            class="px-2 col-tablet-6 mb-4">
            <router-link :to="{
              name: 'blog-post',
              params: {
                category: article.category.slug,
                slug: article.slug
              }
            }">
              <article>
                <div v-if="article.post_images && article.post_images.length > 0">
                  <img :alt="article.slug" :src="article.post_images[0].image_url" class="blog-img" />
                </div>
                <h3 class="article-title">{{ article.title }}</h3>
                <div class="text-grey text-left">
                  {{ article.date | moment("from") }}
                </div>
              </article>
            </router-link>
          </b-col>
        </b-row>
      </div>

      <div class="row justify-content-center text-center px-3 px-md-0 py-5">
        <div
          class="col mx-auto bg-light-blue text-left row-card border-radius-lg box-shadow-lg hover-transform border-radius">
          <div class="row py-4 px-3 justify-content-center align-items-center">
            <div class="col-md-2 d-flex justify-content-center">
              <div class="icon-circle">
                <IconStars class="icon-lg" />
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center text-center text-md-left my-3">
              <div>
                <h3 class="text-bold mb-0 h2">
                  Intégrez les données immobilières de Melo en vous connectant à notre API
                </h3>
                <p class="text-white-50 mt-2 mb-0">
                  Accédez à notre API complète et sécurisée
                </p>
              </div>
            </div>
            <div class="col-md-2 d-flex justify-content-center">
              <div>
                <b-link to="/api" @click.native="$scrollToTop"
                  class="btn-blue text-bold text-uppercase px-4 py-3 my-3 border-radius hover-scale">
                  En savoir +
                </b-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/bottombar/Footer.vue";
import IconStars from "@/components/icons/IconStars.vue";
import articlesData from '../../articles.json';

export default {
  name: "blogHome",
  components: {
    Footer,
    IconStars,
  },

  metaInfo: {
    title: "Blog",
    titleTemplate: "%s — Melo",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content: "Melo vous accompagne dans toutes les questions relatives au marché de immobilier !",
      },
      {
        property: "og:title",
        content: "%s — Melo",
      },
      { property: "og:site_name", content: "Melo" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.melo.io/blog",
      },
      {
        property: "og:image",
        content: "https://www.melo.io/assets/socials/fb-cover.png",
      },
      {
        property: "og:description",
        content: "Melo vous accompagne dans toutes les questions relatives au marché de immobilier !",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.melo.io/blog" }],
  },

  data() {
    return {
      articles: [],
      articlesPerCategory: 3,
    };
  },

  created() {
    this.articles = articlesData;
  },

  computed: {
    categories() {
      // Create a Map to track unique categories using the slug as key
      const uniqueCategories = new Map();

      this.articles
        .filter(article => article.category && article.category.name && article.category.slug)
        .forEach(article => {
          const { slug, name } = article.category;
          if (!uniqueCategories.has(slug)) {
            uniqueCategories.set(slug, { name, slug });
          }
        });

      // Convert Map values to array and sort by name
      return Array.from(uniqueCategories.values())
        .sort((a, b) => a.name.localeCompare(b.name));
    }
  },

  methods: {
    getLatestArticlesByCategory(category) {
      return this.articles
        .filter(article => {
          return article.category &&
            article.category.name === category.name &&
            (!article.post_images || article.post_images.length === 0 || article.post_images[0].image_url)
        })
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, this.articlesPerCategory);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

* {
  letter-spacing: 1px;
}

.category-title {
  font-size: 24px;
  font-weight: bold;
  color: $body-text;
  text-transform: capitalize;
  text-align: left;
  margin: 0 0 1.5rem 1rem;
  padding: 0.75rem 1.5rem;
  display: inline-flex;
  align-items: center;
  background-color: #f8f9fa; // Light background
  border-radius: $radius;
  border: 1px solid #e9ecef; // Light border
  transition: all 0.2s ease;
  text-decoration: none;

  &::after {
    content: '›';
    margin-left: 8px;
    font-size: 28px;
    line-height: 0;
    position: relative;
    top: 2px;
    transition: transform 0.2s ease;
  }

  &:hover {
    color: $blue;
    background-color: white;
    border-color: $blue;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
    text-decoration: none;

    &::after {
      transform: translateX(3px);
    }
  }
}

.article-title {
  text-overflow: ellipsis;
  margin-top: 1rem;
  line-height: 26px;
  letter-spacing: 0.2px;
  font-size: 18px;
  overflow: hidden;
  text-align: left;
  color: $body-text;
  font-weight: bold;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.blog-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: $radius;
}

article {
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);

    .article-title {
      color: $blue;
    }
  }
}

.btn-outline-primary {
  border-radius: $radius;
  padding: 0.5rem 1rem;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    background-color: $blue;
    color: white;
  }
}
</style>

<style lang="scss">
.row-card {
  svg {
    align-self: start;
    margin-right: 1rem;
    width: 4rem;

    path {
      fill: black !important;
    }
  }
}
</style>